export default {
  languages: {
    spanish: 'Español',
    english: 'Inglés',
    french: 'Francés',
    german: 'Alemán'
  },
  name: 'Nombre',
};



// WEBPACK FOOTER //
// ./src/languages/es.js